import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// *load ข้อมูลต้นแหล่ง
function* surveySourcingLoadSource(action) {
  const {
    data: { location_list, location_type, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/survey-sourcing/get-location`,
      { location_list, location_type },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.surveySourcingLoadSource.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.surveySourcingLoadSource.failure())
  }
}

// *load table log สำรวจต้นแหล่ง
function* surveySourcingLoadTableLog(action) {
  const {
    data: {
      page,
      page_size,
      order_by,
      order_type,

      type,
      filter_obj,

      limit_export,
      file_value_pdf,

      mill_location_list,

      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/survey-sourcing/list`,
      {
        page,
        page_size,
        order_by,
        order_type,

        type,
        filter_obj,

        limit_export,
        file_value_pdf,

        mill_location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.surveySourcingLoadTableLog.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.surveySourcingLoadTableLog.failure())
  }
}

// *load detail สำรวจต้นแหล่ง
function* surveySourcingDetail(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/survey-sourcing/get-detail`,
      { id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.surveySourcingDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.surveySourcingDetail.failure())
  }
}

// *delete ข้อมูล
function* surveySourcingDelete(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/survey-sourcing/delete`,
      { id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.surveySourcingDelete.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.surveySourcingDelete.failure())
  }
}

// *add new location
function* surveySourcingAddNewLocation(action) {
  const {
    data: { survey_sourcing_id, location_name, lat, lng, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/survey-sourcing/create-location`,
      {
        survey_sourcing_id,
        location_name,
        lat,
        lng,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.surveySourcingAddNewLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.surveySourcingAddNewLocation.failure())
  }
}

// *edit location
function* surveySourcingEditLocation(action) {
  const {
    data: {
      survey_sourcing_id,
      location_id,
      location_name,
      lat,
      lng,
      custom_location,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/survey-sourcing/edit-location`,
      {
        survey_sourcing_id,
        location_id,
        location_name,
        lat,
        lng,
        custom_location,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.surveySourcingEditLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.surveySourcingEditLocation.failure())
  }
}

export default function* watchSurveySourcing() {
  yield all([
    takeEvery(
      actions.SURVEY_SOURCING_LOAD_SOURCE.REQUEST,
      surveySourcingLoadSource
    ),
    takeEvery(
      actions.SURVEY_SOURCING_LOAD_TABLE_LOG.REQUEST,
      surveySourcingLoadTableLog
    ),
    takeEvery(actions.SURVEY_SOURCING_DETAIL.REQUEST, surveySourcingDetail),
    takeEvery(actions.SURVEY_SOURCING_DELETE.REQUEST, surveySourcingDelete),
    takeEvery(
      actions.SURVEY_SOURCING_ADD_NEW_LOCATION.REQUEST,
      surveySourcingAddNewLocation
    ),
    takeEvery(
      actions.SURVEY_SOURCING_EDIT_LOCATION.REQUEST,
      surveySourcingEditLocation
    ),
  ])
}
export {
  surveySourcingLoadSource,
  surveySourcingLoadTableLog,
  surveySourcingDetail,
  surveySourcingDelete,
  surveySourcingAddNewLocation,
  surveySourcingEditLocation,
}
